import { Input } from 'antd';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';

export const bankDetailsInputClassName =
  'h-10 rounded-lg border-gray-200 text-sm font-normal text-black hover:border-gray-300 focus:border-gray-400 disabled:!bg-gray-100 disabled:!text-black disabled:opacity-100';

interface BankDetailsTextFieldProps {
  name: string;
  rules?: RegisterOptions;
  placeholder?: string;
  narrow?: boolean;
  disabled?: boolean;
  maxLength?: number;
  formatValue?: (value: string) => string;
}

export function BankDetailsTextField({
  name,
  rules,
  placeholder,
  narrow = false,
  disabled = false,
  maxLength,
  formatValue,
}: BankDetailsTextFieldProps) {
  const { control } = useFormContext();

  const field = (
    <Controller
      name={name}
      control={control}
      rules={disabled ? undefined : rules}
      render={({ field: formField, fieldState }) => (
        <div>
          <Input
            {...formField}
            value={formField.value ?? ''}
            onChange={event => {
              const nextValue = formatValue ? formatValue(event.target.value) : event.target.value;
              formField.onChange(nextValue);
            }}
            placeholder={placeholder}
            disabled={disabled}
            maxLength={maxLength}
            status={fieldState.error ? 'error' : undefined}
            className={bankDetailsInputClassName}
          />
          {fieldState.error?.message ? (
            <p className='mb-0 mt-1 text-sm text-red-500'>{fieldState.error.message}</p>
          ) : null}
        </div>
      )}
    />
  );

  if (narrow) {
    return <div className='w-full max-w-xs'>{field}</div>;
  }

  return field;
}
